  import { 
    FETCHING_PALETTE_IDS_REQUEST, FETCHING_PALETTE_IDS_SUCCEEDED, FETCHING_PALETTE_IDS_FAILED,
    UPDATE_BRANDKIT_ENABLE_TOGGLE_REQUEST, UPDATING_BRANDKIT_ENABLE_TOGGLE_SUCCEEDED, UPDATING_BRANDKIT_ENABLE_TOGGLE_FAILED
   } from 'constants/actionTypes';
  import { call, put, select, takeEvery } from 'redux-saga/effects';
  import axios from 'axios';
  import { createAction } from 'redux-actions';
  import buildUrl from 'build-url';
  import _ from 'lodash';
  
  const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/2.0`;
 
  
  /**
   * Fetch PaletteIds
   */
  export const fetchPaletteIds = createAction(FETCHING_PALETTE_IDS_REQUEST)
  
  const fetchingPaletteIdsSucceeded = createAction(FETCHING_PALETTE_IDS_SUCCEEDED, (response) => {
    return {
      response: response
    }
  })
  
  const fetchingPaletteIdsFailed = createAction(FETCHING_PALETTE_IDS_FAILED, (error) => {
    return {
      error: error
    }
  })
  
  function* fetchPaletteIdsSaga() {
  
    let url = buildUrl(apiUrl, {
      path: `/palette`
    });
  
    const fetchPaletteIdsAPI = () => {
      return axios.get(url).then(response => response.data);
    }
  
    try {
      const response = yield call(fetchPaletteIdsAPI);
      if (response) {
        yield put(fetchingPaletteIdsSucceeded(response));
      }
    } catch (error) {
      yield put(fetchingPaletteIdsFailed(error));
    }
  }

    /**
   * Update Brankit Enable option
  */
    export const updateBrandkitEnableToggle = createAction(UPDATE_BRANDKIT_ENABLE_TOGGLE_REQUEST, (id, request) => {
      return {
        id: id,
        request: request
      }
    })
    
    export const updateBrandkitEnableToggleSucceeded = createAction(UPDATING_BRANDKIT_ENABLE_TOGGLE_SUCCEEDED, (response) => {
      return {
        response: response
      }
    })
    
    export const updateBrandkitEnableToggleFailed = createAction(UPDATING_BRANDKIT_ENABLE_TOGGLE_FAILED, (id, error) => {
      return {
        id: id,
        error: error
      }
    })
    
    function* updateBrandkitEnableToggleSaga(action) {
      const { id, request } = action.payload;
          
      let url = buildUrl(apiUrl, {
        path: `/palette/${id}`
      });
    
      const updateBrandkitEnableToggleAPI = () => {
        return axios.put(url, request).then(response => response.data);
      }

      try {
        const response = yield call(updateBrandkitEnableToggleAPI);
        if (response) {
          yield put(updateBrandkitEnableToggleSucceeded(response));
        }
      } catch (error) {
        yield put(updateBrandkitEnableToggleFailed(error));
      }
    }

  
  export default function* brandKitSaga() {
    yield takeEvery(FETCHING_PALETTE_IDS_REQUEST, fetchPaletteIdsSaga)
    yield takeEvery(UPDATE_BRANDKIT_ENABLE_TOGGLE_REQUEST, updateBrandkitEnableToggleSaga);
  }